import { useTrackingContext, type UseTrackingContextReturn } from './tracking/context';
import { useTrackingDeposit, type UseTrackingDepositReturn } from './tracking/deposit';
import { useTrackingGeneral, type UseTrackingGeneralReturn } from './tracking/general';
import { wrapTrackFunctions } from './tracking/internal/core';
import { useTrackingLogin, type UseTrackingLoginReturn } from './tracking/login';
import { useTrackingNegotiation, type UseTrackingNegotiationReturn } from './tracking/negotiation';
import { useTrackingOffer, type UseTrackingOfferReturn } from './tracking/offer';
import { useTrackingSdp, type UseTrackingSdpReturn } from './tracking/sdp';
import { useTrackingSignup, type UseTrackingSignupReturn } from './tracking/signup';
import { useTrackingSlp, type UseTrackingSlpReturn } from './tracking/slp';
import { useTrackingVas, type UseTrackingVasReturn } from './tracking/vas';

export type UseTrackingReturn = UseTrackingContextReturn &
    UseTrackingDepositReturn &
    UseTrackingGeneralReturn &
    UseTrackingLoginReturn &
    UseTrackingNegotiationReturn &
    UseTrackingOfferReturn &
    UseTrackingSdpReturn &
    UseTrackingSlpReturn &
    UseTrackingSignupReturn &
    UseTrackingVasReturn;

export const useTracking = (): UseTrackingReturn => {
    const contextTracking = useTrackingContext();
    const depositTracking = useTrackingDeposit();
    const generalTracking = useTrackingGeneral();
    const loginTracking = useTrackingLogin();
    const negotiationTracking = useTrackingNegotiation();
    const offerTracking = useTrackingOffer();
    const sdpTracking = useTrackingSdp();
    const slpTracking = useTrackingSlp();
    const signupTracking = useTrackingSignup();
    const vasTracking = useTrackingVas();

    return wrapTrackFunctions({
        ...contextTracking,
        ...depositTracking,
        ...generalTracking,
        ...loginTracking,
        ...negotiationTracking,
        ...offerTracking,
        ...sdpTracking,
        ...slpTracking,
        ...signupTracking,
        ...vasTracking,
    });
};
